import { createReqConsts, createActions } from '../../utils/redux';

export const consts = createReqConsts('auth', 'login-azure-external-redirect', [
  'INIT',
]);

export const actions = createActions(consts);



// WEBPACK FOOTER //
// ./src/redux/auth/authAzureExternalRedirect.js